module.exports = __webpack_public_path__ + "img/UM.c1352e5b.svg";